import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";

export class EmployeeOnboardingInvitationDto extends BaseEntityDto {
  processId: string;
  tokenHash: string;

  @Transform(({ value }) => parseApiDate(value))
  expiresAt: Date;

  @Transform(({ value }) => parseApiDate(value))
  revokedAt?: Date | null;
}
